// Function to get webhook URL from the database
import { query } from "../db.js";

// Utility function to extract session ID from session_device_id
const extractSessionId = (sessionId) => {
    const index = sessionId.lastIndexOf("_");
    if (index === -1) return sessionId; // If no underscore found, return original
    return sessionId.substring(0, index);
};

// Get webhook URL from whatsapp_menu_configs (default webhook URL)
const getDefaultWebhookUrl = async (sessionDeviceId) => {
    const session_device_id = extractSessionId(sessionDeviceId);
    if (!session_device_id) {
        throw new Error("sessionDeviceId is required");
    }

    try {
        const { rows } = await query(
            `SELECT default_webhook_url FROM whatsapp_menu_configs WHERE session_device_id = $1 LIMIT 1`,
            [session_device_id]
        );
        return rows[0]?.default_webhook_url || null;
    } catch (error) {
        console.error("Failed to fetch default_webhook_url:", error.message);
        throw error;
    }
};

// Get webhook URL from whatsapp_menu_items (custom webhook URL for specific menu option)
const getMenuItemWebhookUrl = async (sessionDeviceId, optionKey) => {
    const session_device_id = extractSessionId(sessionDeviceId);
    if (!session_device_id) {
        throw new Error("sessionDeviceId is required");
    }
    if (!optionKey) {
        return null; // optionKey is optional
    }

    try {
        const { rows } = await query(
            `SELECT webhook_url FROM whatsapp_menu_items WHERE session_device_id = $1 AND option_key = $2 LIMIT 1`,
            [session_device_id, optionKey]
        );
        return rows[0]?.webhook_url || null;
    } catch (error) {
        console.error("Failed to fetch menu item webhook_url:", error.message);
        throw error;
    }
};

export { getDefaultWebhookUrl, getMenuItemWebhookUrl, extractSessionId };
